import { Action } from '@/models/logs.model';
import { OrderStatus } from '@/models/order.model';
import { pickThemeColor, pickThemeFontStyles } from '@/theme';
import { Link, Tabs, Tag } from '@/ui';
import styled, { css } from 'styled-components';

export const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const getStatusStyles = (status?: OrderStatus | Action) => {
  switch (status) {
    case OrderStatus.NEW:
    case Action.ORDER_CREATED:
      return css`
        background-color: ${pickThemeColor('BLUE')}1A;
        color: ${pickThemeColor('BLUE')};
      `;
    case OrderStatus.IN_PROGRESS:
      return css`
        background-color: ${pickThemeColor('ORANGE_PRIMARY')}1A;
        color: ${pickThemeColor('ORANGE_PRIMARY')};
      `;
    case OrderStatus.COMPLETED:
      return css`
        background-color: ${pickThemeColor('GREEN')}1A;
        color: ${pickThemeColor('GREEN')};
      `;
    case OrderStatus.CANCELED:
      return css`
        background-color: ${pickThemeColor('RED_CORAL')}1A;
        color: ${pickThemeColor('RED_CORAL')};
      `;
    default:
      return css``;
  }
};

export const StyledStep = styled.span`
  ${pickThemeFontStyles('16', '20')};
  text-transform: capitalize;
  color: ${pickThemeColor('BLACK')};
`;

export const StyledStepsWrap = styled.span`
  display: flex;
  gap: 0.125rem;
`;

export const StyledTag = styled(Tag)<{
  $status?: OrderStatus | Action;
}>`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 0.25rem;
  border-radius: 0.25rem;
  border: none;
  width: fit-content;
  text-transform: capitalize;
  margin: 0;
  ${pickThemeFontStyles('16', '20', 'SEMI_BOLD')};

  ${(props) => getStatusStyles(props.$status)}
`;

export const StyledLink = styled(Link)`
  ${pickThemeFontStyles('16', '20')};
  text-transform: capitalize;
  color: ${pickThemeColor('ORANGE_PRIMARY')};
  text-decoration: underline;

  &:hover {
    text-decoration: none;
    color: ${pickThemeColor('ORANGE_PRIMARY')};
  }
`;

export const StyledLabel = styled.span`
  ${pickThemeFontStyles('14', '20')};
  color: ${pickThemeColor('GREY')};
`;

export const StyledTabs = styled(Tabs)`
  align-items: flex-start;
  width: 100%;
  padding: 0;
  height: 100%;

  .ant-tabs-content-holder {
    padding: 0;
  }

  .ant-tabs-tabpane {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .ant-tabs-content,
  .ant-tabs-content-holder {
    height: 100%;
  }
`;
